/**
 * 들어온 곳으로 돌아갑니다 (DEV_SPEC 3장 뒤로 가기 규칙).
 *
 * 앱 안에서 쌓인 기록이 있으면 한 칸 뒤로, 없으면(주소로 바로 들어왔거나 푸시로
 * 열었으면) fallbackPath 로 바꿔 갑니다. 기록이 없는데 뒤로 가면 앱 밖으로
 * 나가 버립니다 (히어로챗 Chat.jsx 의 goBack 과 같은 규칙).
 *
 * 안드로이드 하드웨어 뒤로 버튼은 같은 history 를 쓰므로 같은 규칙을 따릅니다.
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function hasInAppHistory() {
    // React Router 가 history.state.idx 에 앱 안의 위치를 적습니다. 0 이면 첫 화면입니다.
    return (window.history.state?.idx ?? 0) > 0;
}

export function useGoBack(fallbackPath = '/') {
    const navigate = useNavigate();

    return useCallback(() => {
        if (hasInAppHistory()) {
            navigate(-1);
            return;
        }
        navigate(fallbackPath, { replace: true });
    }, [navigate, fallbackPath]);
}
